import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, } from '@angular/material';
var ClientFormAddressComponent = /** @class */ (function () {
    function ClientFormAddressComponent(formBuilder, errorsService, route, authService, zipCodeService, snackBar, location) {
        this.formBuilder = formBuilder;
        this.errorsService = errorsService;
        this.route = route;
        this.authService = authService;
        this.zipCodeService = zipCodeService;
        this.snackBar = snackBar;
        this.location = location;
        this.initalized = false;
        this.kindInvalid = false;
    }
    ClientFormAddressComponent.prototype.ngOnInit = function () {
        this.customerID = this.route.snapshot.paramMap.get('customerID');
        this.addressID = this.route.snapshot.paramMap.get('addressID');
        this.formGroup = this.formBuilder.group({
            addressTitle: [null, [Validators.required]],
            street: [null, [Validators.required]],
            addressNumber: [null, [Validators.required]],
            complement: [null, []],
            zipCode: [null, [Validators.required]],
            neighborhood: [null, [Validators.required]],
            city: [null, [Validators.required]],
            state: [null, [Validators.required]],
            country: [null, [Validators.required]],
            kind: [null, []],
        });
        if (this.addressID) {
            this.addressFindOne();
        }
    };
    ClientFormAddressComponent.prototype.addressFindOne = function () {
        var _this = this;
        this.authService.addressFindOne(this.addressID, this.customerID).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.formGroup.patchValue({
                    addressTitle: response.addressTitle,
                    street: response.street,
                    addressNumber: response.addressNumber,
                    complement: response.complement,
                    zipCode: response.zipCode,
                    neighborhood: response.neighborhood,
                    city: response.city,
                    state: response.state,
                    country: response.country,
                    kind: response.kind,
                });
                return [2 /*return*/];
            });
        }); }, function (error) {
            _this.snackBar.open(error.error.message);
        });
    };
    ClientFormAddressComponent.prototype.getAddress = function () {
        var _this = this;
        if (this.formGroup.value.zipCode) {
            this.zipCodeService.getAddress(this.formGroup.value.zipCode).subscribe(function (address) {
                _this.formGroup.patchValue({
                    state: address.uf,
                    city: address.localidade,
                    neighborhood: address.bairro,
                    street: address.logradouro,
                });
            });
        }
    };
    ClientFormAddressComponent.prototype.onChange = function () {
        this.kindInvalid = false;
    };
    ClientFormAddressComponent.prototype.goBack = function () {
        this.location.back();
    };
    ClientFormAddressComponent.prototype.submit = function () {
        var _this = this;
        this.kindInvalid = !this.formGroup.value.kind;
        if (!this.formGroup.valid || this.kindInvalid) {
            this.snackBar.open('Preencha corretamente os campos e tente novamente.');
            return false;
        }
        var data = {
            addressTitle: this.formGroup.value.addressTitle,
            street: this.formGroup.value.street,
            addressNumber: this.formGroup.value.addressNumber,
            complement: this.formGroup.value.complement ? this.formGroup.value.complement : '',
            zipCode: this.formGroup.value.zipCode,
            neighborhood: this.formGroup.value.neighborhood,
            city: this.formGroup.value.city,
            state: this.formGroup.value.state,
            country: this.formGroup.value.country,
            customerId: this.customerID,
            kind: this.formGroup.value.kind,
        };
        if (this.addressID) {
            this.authService.updateAddress(this.addressID, data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    this.location.back();
                    this.snackBar.open('Endereço cadastrado com sucesso.');
                    return [2 /*return*/];
                });
            }); }, function (error) {
                _this.snackBar.open(error.error.message);
            });
        }
        else {
            this.authService.createAddress(data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    this.location.back();
                    this.snackBar.open('Endereço cadastrado com sucesso.');
                    return [2 /*return*/];
                });
            }); }, function (error) {
                _this.snackBar.open(error.error.message);
            });
        }
    };
    return ClientFormAddressComponent;
}());
export { ClientFormAddressComponent };
